import React from 'react';

import {
  PlayArrowIcon,
  PauseIcon,
  DeleteIcon,
  Actions,
  Action,
  MoreVertIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  EDIT_BID_AMOUNT,
  EDIT_DAILY_BUDGET,
  EDIT_STATUS,
  EDIT_LIFETIME_BUDGET,
} from 'scenes/Trackers/Tracker/components/TrackerDataTable/components/EditRow';
import {
  STATUS_ACTIVE,
  STATUS_DELETED,
  STATUS_PAUSED,
} from 'scenes/Trackers/components/MetricStatus';

const BulkActionsToolbar = ({
  bulkActions,
  onEditBulk,
  onPresentSelected,
  selectedValues,
  disablePresentRows,
  reset,
}) => {
  const changeStatus = (value) => {
    onEditBulk(EDIT_STATUS, value, { selectedValues, reset });
  };

  const handleChangeBidAmount = () => {
    onEditBulk(EDIT_BID_AMOUNT, undefined, { selectedValues, reset });
  };

  const handleChangeDailyBudget = () => {
    onEditBulk(EDIT_DAILY_BUDGET, undefined, { selectedValues, reset });
  };

  const handleChangeLifetimeBudget = () => {
    onEditBulk(EDIT_LIFETIME_BUDGET, undefined, { selectedValues, reset });
  };

  const handlePlay = () => {
    changeStatus(STATUS_ACTIVE);
  };

  const handlePause = () => {
    changeStatus(STATUS_PAUSED);
  };

  const handleDelete = () => {
    changeStatus(STATUS_DELETED);
  };

  const handlePresentSelected = () => {
    onPresentSelected(selectedValues);
    reset();
  };

  return (
    <Permissions actions={bulkActions}>
      {({ isActionAllowed }) => (
        <Actions>
          <Action
            label={'Present selected'}
            button
            onClick={handlePresentSelected}
            disabled={disablePresentRows}
          />
          {isActionAllowed(EDIT_BID_AMOUNT) && (
            <Action
              label={'Edit Bid Amount'}
              button
              onClick={handleChangeBidAmount}
            />
          )}
          {isActionAllowed(EDIT_DAILY_BUDGET) && (
            <Action
              label={'Edit Daily Budget'}
              button
              onClick={handleChangeDailyBudget}
            />
          )}
          {isActionAllowed(EDIT_LIFETIME_BUDGET) && (
            <Action
              label={' Edit Lifetime Budget'}
              button
              onClick={handleChangeLifetimeBudget}
            />
          )}
          {isActionAllowed(EDIT_STATUS) && (
            <Action icon={<MoreVertIcon />}>
              <Action
                id={'play'}
                icon={<PlayArrowIcon />}
                label={'Start'}
                onClick={handlePlay}
              />

              <Action
                id={'pause'}
                icon={<PauseIcon />}
                label={'Pause'}
                onClick={handlePause}
              />
              <Action
                id={'delete'}
                icon={<DeleteIcon />}
                label={'Delete'}
                onClick={handleDelete}
              />
            </Action>
          )}
        </Actions>
      )}
    </Permissions>
  );
};
export default BulkActionsToolbar;
